<template>
  <div class="container">
    <div class="content1">
      <div class="title">企业简介</div>
      <div class="content">
        杭州邦睿科技有限公司成立于2015年07月15日，注册资本5000万元，注册地位于浙江省杭州市滨江区长河街道建业路511号华创大厦14层1403室，法定代表人为汪陈笑。经营范围包括技术开发、技术服务、技术咨询、成果转让：计算机软硬件、计算机系统集成、电子产品。
      </div>
    </div>
    <div class="content2">
      <div class="title">加入我们</div>
      <div class="table">
        <el-table
          :data="tableData"
          stripe
          style="width: 70%; margin: 10px auto"
          :header-cell-style="{
            background: '#5ebcf2',
            color: '#04498c',
            fontSize: '16px',
          }"
        >
          <el-table-column prop="jobs" label="职位" width="200" align="center">
          </el-table-column>
          <el-table-column prop="city" label="城市" width="180" align="center">
          </el-table-column>
          <el-table-column prop="email" label="投递邮箱" align="center">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  components: {},
  data() {
    return {
      tableData: [
        {
          id: 1001,
          jobs: "前端开发工程师",
          city: "杭州、合肥、上海",
          email: "guanff@bsfit.com.cn",
        },
        {
          id: 1002,
          jobs: "Java开发工程师",
          city: "杭州、合肥、上海",
          email: "guanff@bsfit.com.cn",
        },
        {
          id: 1003,
          jobs: "测试工程师",
          city: "杭州",
          email: "guanff@bsfit.com.cn",
        },
        {
          id: 1004,
          jobs: "产品与需求分析师",
          city: "杭州",
          email: "guanff@bsfit.com.cn",
        },
        {
          id: 1005,
          jobs: "销售经理",
          city: "杭州",
          email: "guanff@bsfit.com.cn",
        },
        { id: 1006, jobs: "招聘", city: "杭州", email: "guanff@bsfit.com.cn" },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.container {
  box-sizing: border-box;
  padding: 40px;
  margin: 90px auto 20px auto;
  width: 980px;
  background-color: #fff;
  .title {
    font-size: 35px;
    line-height: 71px;
    color: #4b565c;
    margin-bottom: 5px;
  }
  .content1 {
    margin-bottom: 30px;
    .content {
      font-size: 14px;
      line-height: 24px;
      color: #48637b;
    }
  }
}
</style>
